if (!customElements.get('custom-dimensions')) {
  customElements.define(
    'custom-dimensions',
    class CustomDimensions extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.bindEvents();
        this.validateDimensions();
      }

      bindEvents() {
        // Plus/Minus Button Events
        this.querySelectorAll('.quantity__button').forEach(button => {
          button.addEventListener('click', this.handleButtonClick.bind(this));
        });

        // Input Change Events
        this.querySelectorAll('.custom-dimension-input__field').forEach(input => {
          input.addEventListener('input', this.handleInputChange.bind(this));
          input.addEventListener('blur', this.validateDimensions.bind(this));
        });

        // Form Submit Event
        const form = this.closest('form');
        if (form) {
          form.addEventListener('submit', this.handleFormSubmit.bind(this));
        }
      }

      handleButtonClick(event) {
        const button = event.currentTarget;
        const input = button.closest('.custom-dimension-input').querySelector('.custom-dimension-input__field');
        const currentValue = parseInt(input.value) || 0;

        if (button.name === 'plus') {
          input.value = currentValue + 1;
        } else if (button.name === 'minus' && currentValue > 1) {
          input.value = currentValue - 1;
        }

        // Trigger input event for validation
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }

      handleInputChange(event) {
        const input = event.target;
        let value = parseInt(input.value);

        // Ensure minimum value of 1
        if (value < 1 || isNaN(value)) {
          input.value = 1;
          value = 1;
        }

        this.validateDimensions();
      }

      isFieldVisible(input) {
        // wenn das Input z.B. via CSS display:none hat, ist offsetParent null
        return !!(input && input.offsetParent !== null);
      }

      validateDimensions() {
        const heightInput = this.querySelector('input[data-dimension="height"]');
        const widthInput = this.querySelector('input[data-dimension="width"]');
        const errorElement = this.querySelector('.custom-dimensions__error');
        const form = this.closest('form');
        const submitButton = form ? form.querySelector('[type="submit"]') : null;

        // Required-Status an Sichtbarkeit koppeln
        [heightInput, widthInput].forEach(input => {
          if (!input) return;
          if (this.isFieldVisible(input)) {
            input.setAttribute('required', 'required');
          } else {
            input.removeAttribute('required');
          }
        });

        let isValid = true;
        let anyValueEntered = false;

        // Höhe validieren (nur wenn vorhanden & sichtbar)
        if (heightInput && this.isFieldVisible(heightInput)) {
          const raw = heightInput.value.trim();
          const value = parseInt(raw);
          if (raw !== '') anyValueEntered = true;

          if (!raw || isNaN(value) || value <= 0) {
            isValid = false;
          }
        }

        // Breite validieren (nur wenn vorhanden & sichtbar)
        if (widthInput && this.isFieldVisible(widthInput)) {
          const raw = widthInput.value.trim();
          const value = parseInt(raw);
          if (raw !== '') anyValueEntered = true;

          if (!raw || isNaN(value) || value <= 0) {
            isValid = false;
          }
        }

        // Fehler nur anzeigen, wenn der User überhaupt etwas eingegeben hat
        if (errorElement) {
          if (!isValid && anyValueEntered) {
            errorElement.style.display = 'block';
          } else {
            errorElement.style.display = 'none';
          }
        }

        // Submit-Button sperren / freigeben
        if (submitButton) {
          if (!isValid) {
            submitButton.setAttribute('aria-disabled', 'true');
            submitButton.classList.add('disabled');
          } else {
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('disabled');
          }
        }

        return isValid;
      }

      handleFormSubmit(event) {
        if (!this.validateDimensions()) {
          event.preventDefault();
          const errorElement = this.querySelector('.custom-dimensions__error');
          if (errorElement) {
            errorElement.style.display = 'block';
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return false;
        }
      }
    }
  );
}

// Initialize existing custom dimensions on page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('custom-dimensions').forEach(element => {
    if (!element.initialized) {
      element.initialized = true;
      // Konstruktor übernimmt die Initialisierung
    }
  });
});
